import * as Yup from 'yup';
import i18n from 'i18n';
import { EXTERNALEMAIL_BRITY_WORKS, PASSWORD_RULE, SIGNUP_RADIO, TERMS_TYPE } from 'constants/IncorporationConstants';
import * as validator from 'components/Common/InputBox/validator';

Yup.addMethod(Yup.string, 'checkSpecialNm', validator.checkSpecialNm);
Yup.addMethod(Yup.string, 'financialChar', validator.financialChar);
Yup.addMethod(Yup.string, 'isMixedCharDigitSomeSpecialChar', validator.isMixedCharDigitSomeSpecialChar);
Yup.addMethod(Yup.string, 'noRepeat', validator.noRepeat);
Yup.addMethod(Yup.string, 'noSpace', validator.noSpace);
Yup.addMethod(Yup.string, 'noSeqNum', validator.noSeqNum);
Yup.addMethod(Yup.string, 'isAgreementTrue', validator.isAgreementTrue);
Yup.addMethod(Yup.string, 'includeUserInfoForUserIdEmpNo', validator.includeUserInfoForUserIdEmpNo);
Yup.addMethod(Yup.string, 'includeUserInfoForTelNo', validator.includeUserInfoForTelNo);
Yup.addMethod(Yup.string, 'notIncludeBrityDomain', validator.notIncludeBrityDomain);

const SNM = Yup.string().trim().required('MB_M_MANAGER_JS_ENTERLASTNAME').checkSpecialNm();
const GNM = Yup.string().trim().required('MB_M_MANAGER_JS_ENTERNAME').checkSpecialNm();
const FNM = Yup.string().checkSpecialNm();
const specialChar = '[!@#$%&*^]';

const PWD = Yup.string()
  .required('MB_T_CPW_HOLDER')
  .max(PASSWORD_RULE.PASSWORD_MAX, i18n.t('MB_M_MAX_LENGTH', { digit: PASSWORD_RULE.PASSWORD_MAX }))
  .min(PASSWORD_RULE.PASSWORD_MIN, i18n.t('MB_M_MIN_LENGTH', { digit: PASSWORD_RULE.PASSWORD_MIN }))
  .matches(specialChar, 'MB_M_INCLUD_SPECIAL_CHAR')
  .financialChar()
  .noSpace()
  .noRepeat()
  .noSeqNum()
  .includeUserInfoForUserIdEmpNo()
  .includeUserInfoForTelNo();
const USER_ID = Yup.string().when('svcType', {
  is: TERMS_TYPE.PORTAL,
  then: schema => schema.required('MB_T_ID_HOLDER'),
  otherwise: schema => schema.required('MB_M_PWD_ENTER_EXTMAIL').email('MB_M_PWD_ENTER_EXTMAIL'),
});
const COMPNM = Yup.string().required('MB_M_MANAGER_JS_ENTERCOMPANYNAME').noSpace();
const AGREEMENT_REQ = Yup.string().required('MB820').isAgreementTrue('MB820');
const AGREEMENT_Global = Yup.string().when('zoneCd', {
  is: val => val !== 'KR',
  then: schema => schema.required('MB820').isAgreementTrue('MB820'),
});

export const confirmPasswordSchema = () => {
  return PWD.oneOf([Yup.ref('pwd'), null], 'MB_M_COMMON_JS_PASSNOTMATCH');
};

export const IncorporationOfTermsSchema = () => {};

export const InviteOfTermsSchema = () => {
  return Yup.object({
    userId: USER_ID,
    otp: Yup.string().required('MB_M_REQUIRED'),
    pwd: PWD,
    pwdConfirm: confirmPasswordSchema(),
    snm: SNM,
    gnm: GNM,
    fnm: FNM,
    // CMARKR: AGREEMENT_REQ,
    // PIARKR: AGREEMENT_REQ,
    // POARKR: AGREEMENT_Global,
  }).required();
};

// 즉시발급
export const InstantOfTermsSchema = () => {
  return Yup.object({
    cnpwd: Yup.string().required('MB_M_COMMON_JS_ENTERPASS'),
    pwd: PWD.notOneOf([Yup.ref('cnpwd'), null], 'MB0719'),
    pwdConfirm: PWD.oneOf([Yup.ref('pwd'), null], 'MB_M_COMMON_JS_PASSNOTMATCH'),
    snm: SNM,
    gnm: GNM,
    fnm: FNM,
    // CMARKR: AGREEMENT_REQ,
    // PIARKR: AGREEMENT_REQ,
    // POARKR: AGREEMENT_Global,
  }).required();
};

// 무료가입
export const AdminIncorporationOfTermsSchema = () => {
  return Yup.object({
    compNm: COMPNM,
    userId: USER_ID,
    pwd: PWD,
    snm: SNM,
    pwdConfirm: confirmPasswordSchema(),
    gnm: GNM,
    fnm: FNM,
    email: Yup.string().when('svcType', {
      is: TERMS_TYPE.PORTAL,
      then: schema => schema
        .required('MB_M_PWD_ENTER_EXTMAIL')
        .email('MB_M_PWD_ENTER_EXTMAIL')
        .notIncludeBrityDomain(EXTERNALEMAIL_BRITY_WORKS, 'MB_M_EXCEPT_BRITYWORKS_ADDR'),
    }),
    PIARKR: AGREEMENT_REQ,
    CMARKR: AGREEMENT_REQ,
    SVCRKR: AGREEMENT_REQ,
    POARKR: AGREEMENT_Global,
  }).required();
};

// 신규가입
export const AccountIncorporationOfTermsSchema = () => {
  return Yup.object({
    optionMobileNationCode: Yup.string().when('authRadio', {
      is: SIGNUP_RADIO[0].value,
      then: schema => schema.required('MB_M_VALIDATE_NATIONNUMBER'),
    }),
    pwd: PWD,
    pwdConfirm: confirmPasswordSchema(),
    snm: SNM,
    gnm: GNM,
    fnm: FNM,
    email: Yup.string()
      .email('MB_M_MANAGER_JS_MAILFORMATINVALID')
      .notIncludeBrityDomain(EXTERNALEMAIL_BRITY_WORKS, 'MB_M_EXCEPT_BRITYWORKS_ADDR'),
    // PIARKR: AGREEMENT_REQ,
    // CMARKR: AGREEMENT_REQ,
    // POARKR: AGREEMENT_Global,
  }).required();
};
// 재동의
export const ReAgreementOfTermsSchema = () => {
  return Yup.object({
    PIARKR: AGREEMENT_REQ,
    CMARKR: AGREEMENT_REQ,
    POARKR: AGREEMENT_Global,
  }).required();
};
export const validLength = param => {
  return Yup.string().required().min(PASSWORD_RULE.PASSWORD_MIN).max(PASSWORD_RULE.PASSWORD_MAX).isValidSync(param);
};

export const validSpecialChar = param => {
  return Yup.string()
    .required()
    .financialChar()
    .isMixedCharDigitSomeSpecialChar()
    .matches(specialChar, 'MB_M_INCLUD_SPECIAL_CHAR')
    .isValidSync(param);
};

export const validRepeat = param => {
  return Yup.string().required().noRepeat().isValidSync(param);
};

export const validDigit = param => {
  return Yup.string().required().noSeqNum().isValidSync(param);
};

export const validPersonalInfo = (param, userId, mphonNo) => {
  return Yup.string()
    .required()
    .includeUserInfoForTelNo(mphonNo)
    .includeUserInfoForUserIdEmpNo(userId)
    .isValidSync(param);
};

export default IncorporationOfTermsSchema;
